import React from "react";

import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { addCommasToNum } from "../utils";

const BarChart = ({
  setHoveredEventID,
  eventsToRender,
  setSelectedEventID,
}) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <RechartsBarChart
        data={eventsToRender}
        margin={{
          top: 5,
          left: 5,
          right: 5,
          bottom: 5,
        }}
        onClick={(e) => {
          e && setSelectedEventID(e.activeLabel);
          setHoveredEventID(null);
        }}
        onMouseMove={(state) =>
          state.isTooltipActive
            ? setHoveredEventID(state.activeLabel)
            : setHoveredEventID(null)
        }
        onMouseLeave={() => setHoveredEventID(null)}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="eventID" />

        <YAxis
          tickFormatter={(val) => addCommasToNum(val, 3, 0)}
          domain={[0, (dataMax) => (dataMax + 100).toFixed()]}
          type="number"
          // width={70}
        />
        <Tooltip formatter={(val) => addCommasToNum(val)} />
        <Legend />

        <Bar
          dataKey="Live"
          unit={" GB"}
          barSize={20}
          fill="rgba(0, 162, 255, 0.8)"
        />
        <Bar
          dataKey="Vod"
          unit={" GB"}
          barSize={20}
          fill="rgba(255, 159, 64, 0.8)"
        />
      </RechartsBarChart>
    </ResponsiveContainer>
  );
};

export default BarChart;
